import API from '@/api/base'

export const state = {
  site: {},
  siteName: '',
}

export const getters = {
  getShopClosed: (state) => state.site.shopClosed,
  getShopClosedMsg: (state) => state.site.shopClosedMsg,
  getSite: (state) => state.site,
  getSites: (state) => state.sites,
  getSiteCateringDesc: (state) => state.site.shopCateringDescription,
  getSiteParentsDesc: (state) => state.site.shopParentDescription,
  getSiteId: (state) => state.site.id,
  getSiteSlug: (state) => state.site.slug,
  getSiteName: (state) => state.site.name || state.siteName,
}

export const actions = {
  fetchSite: ({ commit, state, dispatch }, { slug }) => {
    if (state.site && state.site.slug && state.site.slug === slug) {
      return state.site
    }
    const request = new Promise((resolve, reject) => {
      API.find('site', slug, {
        platform: 'shop',
      })
        .then((response) => {
          commit('SET_SITE', response.data)
          if (response.data.name) {
            commit('SET_SITE_NAME', response.data.name)
          }
          dispatch('shopBanners/fetchBanners', {}, { root: true })
          resolve(state.site)
        })
        .catch(() => {})
    })
    return request
  },
  fetchSites: ({ commit }, itemId) =>
    new Promise((resolve, reject) => {
      API.findAll('sites', {
        platform: 'shop',
      })
        .then((response) => {
          commit('SET_SITES', response.data)
          resolve(state.sites)
        })
        .catch(() => {})
    }),
}

export const mutations = {
  SET_SITE(state, site) {
    state.site = site
  },
  SET_SITE_NAME(state, siteName) {
    state.siteName = siteName
  },
  SET_SITES(state, sites) {
    state.sites = sites
  },
}
